'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wind = wind;
var getVelLevel = exports.getVelLevel = function getVelLevel(vel) {
  var levels = [0.3, 1.6, 3.4, 5.5, 8.0, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7, 37.0, 41.5, 46.2, 51.0, 56.1, 61.3, 66.8, 72.4];

  for (var i = 0; i < levels.length; i++) {
    if (vel < levels[i]) return i;
  }
  return 20;
};
var getDirLevel = exports.getDirLevel = function getDirLevel(dir) {
  var windDir = ['北风', '东北风', '东风', '东南风', '南风', '西南风', '西风', '西北风'];

  var dirBound = [22.5, 67.5, 112.5, 157.5, 202.5, 247.5, 292.5, 337.5];
  for (var i = 0; i < dirBound.length - 1; i++) {
    if (dir > dirBound[i] && dir <= dirBound[i + 1]) return windDir[i + 1];
  }
  return windDir[1];
};

var getWindColor = exports.getWindColor = function getWindColor(list, val) {
  for (var i = 0; i < list.length; i++) {
    if (i === 0) continue;
    if (list[i].value > val) {
      if (i === 1) {
        return 'black';
      }
      if (i === 2) {
        return 'green';
      }
      if (i === 3) {
        return 'blue';
      }
    }
  }
  return 'red';
};

var _rootUrl = window.PAGE_CONFIG.BASE_URL + '/roa1080/';

function windLevel(speed) {
  var levels = [0.3, 1.6, 3.4, 5.5, 8.0, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7, 37.0, 41.5, 46.2, 51.0, 56.1, 61.3, 66.8, 72.4];

  for (var i = 0, len = levels.length; i < len; i++) {
    if (speed < levels[i]) return i + '';
  }
  return '20';
}

function windDir(dir) {
  var dirBound = [22.5, 67.5, 112.5, 157.5, 202.5, 247.5, 292.5, 337.5];
  for (var i = 0, len = dirBound.length; i < len - 1; i++) {
    if (dir > dirBound[i] && dir <= dirBound[i + 1]) return i + 2 + '';
  }
  return '1';
}

function wind(speed, dir) {
  return _rootUrl + 'filelist/wind/' + windLevel(speed) + windDir(dir) + '.png';
}

function windBig(speed, dir) {
  return _rootUrl + 'filelist/bigwind/' + windLevel(speed) + windDir(dir) + '.png';
}


//////////////////
// WEBPACK FOOTER
// ./js/util/wind.js
// module id = 29
// module chunks = 0